import React, { useEffect } from "react";

import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

function ScorePeriodSelector({ school, onChange }) {
  const [_selectedPeriod, setSelectedPeriod] = React.useState("0");
  const [_periods, setPeriods] = React.useState([]);

  useEffect(() => {
    initPeriods();
  }, []);

  const initPeriods = () => {
    switch (school.eid) {
      case "d3969b3d-8d6f-4249-9302-f1770f0776bc":
        // broughton
        setPeriods([
          { value: "1A", label: "1A" },
          { value: "A", label: "Advisory" },
          { value: "2A", label: "2A" },
          { value: "3A", label: "3A" },
          { value: "4A", label: "4A" },
          { value: "1B", label: "1B" },
          { value: "2B", label: "2B" },
          { value: "3B", label: "3B" },
          { value: "4B", label: "4B" },
        ]);
        break;
      case "8456ea19-0580-42b0-b640-5d33c180afe7":
        // panther creek
        setPeriods([
          { value: "1", label: "1" },
          { value: "2", label: "2" },
          { value: "SMART Lunch", label: "SMART Lunch" },
          { value: "3", label: "3" },
          { value: "4", label: "4" },
        ]);
        break;
      default:
        setPeriods([
          { value: "1", label: "1" },
          { value: "2", label: "2" },
          { value: "3", label: "3" },
          { value: "4", label: "4" },
          { value: "5", label: "5" },
          { value: "6", label: "6" },
        ]);
    }
  };

  const handleChangePeriod = (event) => {
    setSelectedPeriod(event.target.value);
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <>
      <InputLabel>Period</InputLabel>
      <Select
        fullWidth
        size="small"
        onChange={handleChangePeriod}
        value={_selectedPeriod}
        sx={{mt:1}}
      >
        <MenuItem key="0" value="0">
          -- ALL PERIODS --
        </MenuItem>
        {_periods.map((period) => (
          <MenuItem key={period.value} value={period.value}>
            {period.label}
          </MenuItem>
        ))}
      </Select>
    </>
  );
}

export default ScorePeriodSelector;
